import styled from 'styled-components'

const Card = styled.div`
  position: relative;
  background-color: white;
  border-radius: 0.5rem;
  ${props =>
    props.elevation
      ? `box-shadow: 0 ${props.elevation}px ${
          props.elevation * 2
        }px rgba(0, 0, 3, 0.1)`
      : null};

  margin-bottom: 2rem;
  &:last-child {
    margin-bottom: 0;
  }
  overflow: hidden;
`
Card.Body = styled.div`
  padding: 1rem;
`

Card.Header = styled.div`
  padding: 1rem;
  background-color: ${props => props.theme.card?.headerBackgroundColor || props.theme.colors.gray200};
  color: ${props => props.theme.card?.headerTextColor || props.theme.colors.gray600};
`

export default Card
